export default function GreyTrophyIco() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 1.5H17V0.75C17 0.3 16.7 0 16.25 0H5.75C5.3 0 5 0.3 5 0.75V1.5H1.25C0.8 1.5 0.5 1.8 0.5 2.25V4.275C0.5 7.575 3.05 10.275 6.35 10.425C6.95 11.25 7.775 11.85 8.75 12.225V14.25H8C6.725 14.25 5.75 15.225 5.75 16.5V18.75C5.75 19.2 6.05 19.5 6.5 19.5H15.5C15.95 19.5 16.25 19.2 16.25 18.75V16.5C16.25 15.225 15.275 14.25 14 14.25H13.25V12.3C14.225 11.925 15.05 11.25 15.65 10.5C18.875 10.275 21.5 7.65 21.5 4.35V2.25C21.5 1.8 21.2 1.5 20.75 1.5ZM2 4.275V3H5V6.75C5 7.5 5.15 8.175 5.375 8.775C3.425 8.25 2 6.45 2 4.275ZM20 4.275C20 6.375 18.575 8.175 16.625 8.775C16.85 8.175 17 7.5 17 6.75V3H20V4.275Z"
        fill="#DCDFE4"
      />
    </svg>
  );
}
